import { createContext, useContext, useMemo, useReducer } from "react";
import { initialState, reducer } from "../reducer/reducer";
import { fetchErs } from "../api/ers";
export const OrochiContext = createContext();
export const OrochiProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  // Memoized ERS fetcher
  const fetchErsData = useMemo(() => {
    return async (slug) => {
      if (!slug) return;
      if (state.ersData && state.ersData[slug]) {
        // Already cached
        return state.ersData[slug];
      }
      try {
        const data = await fetchErs(slug);
        dispatch({ type: "SET_ERS_DATA", payload: { slug, data } });
        return data;
      } catch (error) {
        dispatch({ type: "SET_ERS_ERROR", payload: error.message });
        throw error;
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const value = {
    state,
    dispatch,
    fetchErsData,
  };

  return (
    <OrochiContext.Provider value={value}>{children}</OrochiContext.Provider>
  );
};

export const useOrochi = () => useContext(OrochiContext);
